import { useEffect } from "react";
import { useSelector } from "react-redux";
import Header from "./header/Header";
import styles from "./Layout.module.css";
import Sidebar from "./sidebar/Sidebar";
import Claim from "../../view-claims/claim/Claim";
import { Route, Switch } from "react-router-dom";
import NewClaim from "../../new-claim/NewClaim";
import NewAnonymousClaim from "../../new-anonymous-claim/NewAnonymousClaim";
import ClaimSentInfo from "../../new-anonymous-claim/claim-components/ClaimSentInfo";
import ViewClaims from "../../view-claims/ViewClaims";
import ViewPolicies from "../../view-policies/ViewPolicies";
import AlertModal from "../ui/alert-modal/AlertModal";
import { PromptModal } from "../../ui/prompt-modal/PromptModal";
import ButtonHeader from "../../layout/button-header/ButtonHeader";
import Spinner from "../ui/spinner/Spinner";
import Questionnaire from "../../driveright/questionnaire/Questionnaire";
import OperatorsList from "../../driveright/operators-list/OperatorsList";
import ViewMLUMPolicies from "../../driveright/policy-input/PolicyInput";
import QueryForm from "../../esignature/query-form/QueryForm";
import AfterSubmission from "../../after-submission/AfterSubmission";
import { apps } from "../../../constants/data";
import { driverightTitle } from "../../../constants/messages";
import { SecureRoute, useOktaAuth } from "@okta/okta-react";
import { logout } from "../../../utilities/oktaUtilities";
import { Timer } from "../../timer/Timer";

function Layout() {
  let loading = useSelector((state) => state.app.isLoading);
  let alert = useSelector((state) => state.app.alertModal);
  let prompt = useSelector((state) => state.app.promptModal);
  let config = useSelector((state) => state.app.config);
  let buttonHeaderShowing = useSelector(
    (state) => state.app.buttonHeaderShowing
  );
  let app = useSelector((state) => state.app.app);
  const {oktaAuth, authState} = useOktaAuth();

  const authRequired = async () => {
    logout();
  };

  useEffect(() => {}, [loading, config, buttonHeaderShowing]); //causes rerender when these change

  return (
    <div className={styles.container}>
      <Timer/>
      {loading && <Spinner />}

      {app !== apps.Esignature && <Sidebar />}

      <div className={styles.contentContainer}>
        <div>
          {prompt.show && <PromptModal/>}
        </div>
        <div>
          {alert.show && <AlertModal type={alert.type} body={alert.body} />}
        </div>

        {app === apps.DriveRight ? (
          <Header title={driverightTitle} />
        ) : (
          <Header />
        )}
        {app === apps.Claims && buttonHeaderShowing && <ButtonHeader />}
        <div
          className={
            buttonHeaderShowing
              ? styles.buttonScrollableContainer
              : styles.scrollableContainer
          }
          id="scrollable"
        >
          {config && (
            <Switch>

              {/*anonymous routes */}
              <Route exact path="/fileaclaim" component={NewAnonymousClaim} />
              <Route
                exact
                path="/fileaclaim/thankyou"
                component={ClaimSentInfo}
              />

              {/*CC routes */}
              <SecureRoute exact path="/view" component={ViewClaims} onAuthRequired={authRequired}/>
              <SecureRoute path="/view/claim/:claimId" component={Claim} onAuthRequired={authRequired}/>

              <SecureRoute path="/new" component={NewClaim} onAuthRequired={authRequired}/>
              <SecureRoute
                path="/claimsubmitted/:refNumber"
                component={AfterSubmission}
                onAuthRequired={authRequired}
              />
              <SecureRoute path="/claimsubmitted/" component={AfterSubmission} onAuthRequired={authRequired}/>

              <SecureRoute path="/questionnaire" component={Questionnaire} onAuthRequired={authRequired}/>
              <SecureRoute path="/operators" component={OperatorsList} onAuthRequired={authRequired}/>

              {/*AYS routes */}
              <Route exact path="/policies" component={ViewPolicies} />
              <Route path="/new-a" component={NewClaim}/>
              <Route
                path="/claimsubmitted-a/:refNumber"
                component={AfterSubmission}
              />
              <Route path="/claimsubmitted-a/" component={AfterSubmission} />

              <Route path="/mlumpolicies" component={ViewMLUMPolicies} />
              <Route path="/operators-a" component={OperatorsList} />
              <Route path="/questionnaire-a" component={Questionnaire} />

              <Route path="/envelopes" component={QueryForm} />
            </Switch>
          )}
        </div>
      </div>
    </div>
  );
}

export default Layout;
